import { Navigate, Outlet } from "react-router-dom";
import * as routesNames from "../../../../constants/routes";

import { useEffect, useState } from "react";
import { inductionService } from "../services/inductionService";
import { InductionStatus } from "../Types";
import { Loader } from "../../../../components";

export function InductionGuard() {
  const [status, setStatus] = useState<InductionStatus | null>(null);

  useEffect(() => {
    let cancelled = false;
    inductionService.getStatus().then((s) => !cancelled && setStatus(s))
      .catch(() => !cancelled && setStatus({ required: false }));
    return () => {
      cancelled = true;
    };
  }, []);

  if (status === null) return <Loader />;

  // Block access to HRlense inner routes if induction is required OR feedback is submitted but dual approvals are pending
  const isBlocked = status.required || (status.isCompleted && !status.bothApproved);
  if (isBlocked) {
    return <Navigate to={routesNames.INDUCTIONREDESIGN} replace />;
  }

  return <Outlet />;
}
